import ExternalLink from './ExternalLink';

export default ExternalLink;



// WEBPACK FOOTER //
// ./src/components/ExternalLink/index.js